import { render, staticRenderFns } from "./Datatableserver.vue?vue&type=template&id=75c2400e"
import script from "./Datatableserver.vue?vue&type=script&lang=js"
export * from "./Datatableserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports